<!--
  参数 status: 1、新建 2、待审批 3、待执行 4、审批通过 5、驳回 6、结束
  --------------------------
  @description 申请单组件
  @author xiehan
  @date 2019/01/14
-->
<template>
  <div>
    <g-back :history="[{ name: requestTitle }]"></g-back>
    <el-card class="box-card">
      <div slot="header">
        <div class="request-title" v-text="requestTitle"></div>
      </div>
      <div>
        <el-form ref="requestForm" :model="requestForm" label-position="left">
          <el-col :span="12">
            <el-form-item :label="$t('cloudApplication.applicant')" label-width="50px">
              <span v-text="requestForm.realName" v-if="(status === '1' || status === '5') && assignee"></span>
              <span v-text="requestInfo.applicant" v-else></span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('cloudApplication.department')" label-width="80px">
              <span v-text="requestForm.department" v-if="status === '1'"></span>
              <span v-text="requestInfo.department" v-else></span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-show="(status !== '1' && status !== '5') || !assignee">
            <el-form-item :label="$t('cloudApplication.time')" label-width="70px">
              <span v-text="requestInfo.date"></span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('cloudApplication.expectedTime')" label-width="96px">
              <el-date-picker value-format="timestamp"
                style="width: 180px;"
                v-model="requestForm.expectedTime"
                type="datetime"
                v-if="(status === '1' || status === '5') && assignee">
              </el-date-picker>
              <span v-text="requestInfo.expectedTime" v-else></span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('cloudApplication.siteType')" label-width="40px">
              <g-select v-model="requestForm.site" :list="select_type" v-if="(status === '1' || status === '5') && assignee"></g-select>
              <span v-text="requestInfo.site" v-else></span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('cloudApplication.approver')"
              label-width="60px"
              v-if="(status === '1' || status === '3' || status === '5') && assignee"
              prop="approver"
              :rules="[{ required: (status === '1' || status === '5') && assignee,
                message: $t('common.entryTips') + $t('cloudApplication.approver'), trigger: 'change' }]">
              <el-select
                v-model="requestForm.approver"
                filterable
                v-if="status === '1' || status === '5'"
                :placeholder="$t('common.chooseTips')">
                <el-option
                  v-for="item in select_approver"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <span v-text="requestInfo.approver" v-if="status === '3'"></span>
            </el-form-item>
            <el-form-item :label="$t('cloudApplication.operator')"
              label-width="60px"
              v-if="status === '2' && assignee"
              prop="operator"
              :rules="[{ required: approveForm.opinion, message: $t('common.entryTips') + $t('cloudApplication.operator'), trigger: 'change' }]">
              <el-select v-model="requestForm.operator" filterable :placeholder="$t('common.chooseTips')">
                <el-option
                  v-for="item in ccList"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="(status === '1' || status === '5' || !assignee) ? 12 : 24">
            <el-form-item :label="$t('cloudApplication.ccpeople')" label-width="70px" input-width="auto">
              <el-popover placement="bottom" trigger="click" v-model="showCCList" v-if="(status === '1' || status === '5') && assignee">
                <el-transfer filterable v-model="requestForm.cc" :data="ccList"></el-transfer>
                <el-button type="text"
                  @click="showCCList = !showCCList"
                  slot="reference"
                  v-text="$t('cloudApplication.choose')"></el-button>
              </el-popover>
              <span v-for="(item, index) in requestInfo.cc"
                v-text="item + ' '"
                :key="item + index"
                v-else></span>
            </el-form-item>
          </el-col>
        </el-form>
        <i class="separation-line"></i>
        <slot name="center"></slot>
        <i class="separation-line"></i>
        <el-form ref="reasonForm" :model="reasonForm" input-width="auto" label-width="80px" :rules="reasonRules">
          <el-form-item :label="$t('cloudApplication.reason')" prop="reason">
            <el-input type="textarea"
              v-if="(status === '1' || status === '5') && assignee"
              :rows="3"
              v-model="reasonForm.reason"></el-input>
            <span v-else v-text="requestInfo.reason"></span>
          </el-form-item>
          <el-form-item :label="$t('cloudApplication.remark')" prop="remarks">
            <el-input type="textarea"
              v-if="(status === '1' || status === '5') && assignee"
              :rows="3"
              v-model="reasonForm.remarks"></el-input>
            <span v-else v-text="requestInfo.remarks"></span>
          </el-form-item>
          <el-form-item :label="$t('cloudApplication.option')" v-if="(status !== '1' && status !== '5') && assignee" input-width="180px">
            <el-select v-model="approveForm.opinion" v-if="status === '2'">
              <el-option :label="$t('common.agree')" :value="true"></el-option>
              <el-option :label="$t('common.disagree')" :value="false"></el-option>
            </el-select>
            <span v-else v-text="requestInfo.opinion ? $t('common.agree') : $t('common.disagree')"></span>
          </el-form-item>
          <el-form-item v-if="(status !== '1' && status !== '5') && assignee">
            <el-input type="textarea"
              v-if="status === '2'"
              :rows="3"
              v-model="approveForm.approveRemark"></el-input>
            <span v-else v-text="requestInfo.approveRemark"></span>
          </el-form-item>
        </el-form>
        <slot name="footer"></slot>
        <el-row type="flex" justify="center" style="margin: 20px 0;" v-if="assignee">
          <el-col :span="6">
            <div style="text-align: center;">
              <el-button
                @click="cancelRequest"
                v-text="$t('common.cancel')"
                style="width: 120px;"></el-button>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="text-align: center;">
              <el-button
                v-g-rac="gRac(submitButtonRac)"
                @click="submitRequest"
                type="primary"
                v-text="$t('common.submit')"
                style="width: 120px;"></el-button>
            </div>
          </el-col>
          <el-col :span="6" v-if="isClose">
            <div style="text-align: center;">
              <el-button
                @click="closeOrder"
                type="danger"
                v-text="$t('common.close')"
                style="width: 120px;"></el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import resApplicationBiz from '@/logic/workFlow/resApplicationBiz'
  export default {
    mixins: [rac, dic],
    data () {
      return {
        select_type: {},
        select_approver: [],
        requestForm: {
          realName: '',
          applicant: '',
          department: '',
          date: '',
          site: '',
          approver: '',
          expectedTime: '',
          cc: [],
          processInstanceId: '',
          operator: ''
        },
        showCCList: false,
        ccList: [],
        reasonForm: {
          reason: '',
          remarks: ''
        },
        approveForm: {
          opinion: true,
          approveRemark: ''
        },
        reasonRules: {
          reason: [
            { required: this.status === '1' || this.status === '5',
              message: `${this.$t('common.entryTips')}${this.$t('cloudApplication.reason')}` }
          ]
        },
        isClose: false
      }
    },
    props: {
      submitButtonRac: {
        type: String
      },
      requestTitle: {
        type: String
      },
      status: {
        type: String
      },
      assignee: {
        type: Boolean,
        default: true
      },
      requestInfo: {
        type: Object,
        default: function () {
          return {}
        }
      },
      disAgreeInfo: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    methods: {
      async getDic () {
        await Promise.all([
          this.dGetDictionaryByCode('remoteconfig')
        ])
        this.select_type = { ...this.dDictionary.remoteconfig }
        if (this.status === '1') {
          this.requestForm.site = Object.keys(this.select_type)[0]
        } else if (this.status === '5') {
          this.requestForm.site = Object.keys(this.disAgreeInfo).length > 0
            ? this.disAgreeInfo.info.site : this.requestInfo.site
        }
      },
      getProcessId () {
        resApplicationBiz.startProcess({ 'processDefinitionId': this.$route.query.processDefinitionId }).then(data => {
          this.requestForm.processInstanceId = data.processInstanceId
        })
      },
      getApprover () {
        resApplicationBiz.findUserByTask().then(data => {
          if (this.status === '1') {
            this.requestForm.approver = ''
          } else if (this.status === '5') {
            if (Object.keys(this.disAgreeInfo).length > 0) {
              this.requestForm.approver = data.filter(item => item.name === this.disAgreeInfo.info.approver)[0].id
            }
          }
          this.select_approver = data
        })
      },
      getCCList () {
        resApplicationBiz.findCcpeopleList({ 'currentPage': 1, 'perPageCount': 999 }).then(data => {
          this.ccList = []
          this.requestForm.cc = []
          data.dataList.map(item => {
            this.ccList.push({
              key: item.id,
              label: item.userName
            })
          })
          if (this.status === '5') {
            if (Object.keys(this.disAgreeInfo).length > 0) {
              this.disAgreeInfo.info.cc.map(item => {
                this.requestForm.cc.push(this.ccList.filter(_item => _item.label === item)[0].key)
              })
            }
          }
          this.requestForm.operator = ''
        })
      },
      init () {
        this.isClose = false
        if (this.status === '1') {
          this.requestForm.expectedTime = new Date().getTime() + 86400000
          this.reasonForm.reason = ''
          this.reasonForm.remarks = ''
          this.$nextTick(() => {
            this.$refs.reasonForm.clearValidate()
            this.$refs.requestForm.clearValidate()
          })
          this.getDic()
          this.getProcessId()
          this.getApprover()
          this.getUserInfo()
          this.getCCList()
        } else if (this.status === '2') {
          this.approveForm.opinion = true
          this.approveForm.approveRemark = ''
          this.getCCList()
          this.$nextTick(() => {
            this.$refs.requestForm.clearValidate()
          })
        } else if (this.status !== '5') {
          this.getCCList()
        }
      },
      onStatus5 () {
        this.getCCList()
        this.getDic()
        this.getApprover()
        if (Object.keys(this.disAgreeInfo).length > 0 && this.assignee) {
          this.setRequestForm(this.disAgreeInfo)
          this.getUserInfo()
          this.isClose = true
        } else {
          this.reasonForm.reason = this.requestInfo.reason
          this.reasonForm.remarks = this.requestInfo.remarks
          this.isClose = false
        }
      },
      setRequestForm (data) {
        this.requestForm.date = data.info.date
        this.requestForm.expectedTime = data.info.expectedTime
        this.requestForm.processInstanceId = data.info.processInstanceId
        this.reasonForm.reason = data.info.reason
        this.reasonForm.remarks = data.info.remarks
      },
      getUserInfo () {
        resApplicationBiz.getSelfInfo().then(data => {
          this.requestForm.realName = data.userName
          this.requestForm.applicant = data.id
          this.requestForm.department = data.group
        })
      },
      cancelRequest () {
        if (this.status === '1' || this.status === '5') {
          this.$router.push({ name: 'cloudApplication' })
        } else {
          this.$router.push({ name: 'queryworkOrder' })
        }
        this.$emit('cancelRequest')
      },
      submitRequest () {
        let reasonForm = new Promise((resolve, reject) => {
          this.$refs['reasonForm'].validate((valid) => {
            if (valid) {
              resolve()
            }
          })
        })
        let requestForm = new Promise((resolve, reject) => {
          this.$refs['requestForm'].validate((valid) => {
            if (valid) {
              resolve()
            }
          })
        })
        Promise.all([reasonForm, requestForm]).then(() => {
          let param = {}
          if (this.status === '1' || this.status === '5') {
            param = {
              ...this.requestForm,
              ...this.reasonForm,
              orderType: this.$route.query.processDefinitionId
            }
          } else if (this.status === '2') {
            param = { ...this.approveForm, operator: this.requestForm.operator }
          }
          this.$emit('submitRequest', param)
        })
      },
      closeOrder () {
        resApplicationBiz.closeOrder({ id: this.$route.query.orderId }).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.$router.push({ name: 'cloudApplication' })
        })
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.init()
      })
    }
  }
</script>

<style scoped>
  .el-form {
    overflow: hidden;
  }
  .box-card {
    width: 800px;
  }
  .request-title {
    text-align: center;
    font-size: 15px;
    font-weight: bolder;
  }
  .separation-line {
    display: block;
    height: 1px;
    background: #eee;
    margin: 20px 0;
  }
</style>